  <div class="sheet-block-title"><span translate>sheet-view.related_sheets</span></div>
  <div class="sheetlist-row" *ngFor="let related of sheet.sheets" (click)="emitChangeSheet(related.id)">
      <div class="sheet-icon"></div>
      <span class="sheet-title" [innerHTML]="exerciceSheetService.getContentValueByTypeContent('title', related.content)"></span>
      <button class="seesheet-btn"></button>
  </div>